module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/hero_mob-4bdf0cfde43eabbd6d83cb3ac4d5d3ae.jpg";